import { useEffect } from "react";
import { useSettings } from "../context/SettingsContext";

export const DESIGN_FONTS = {
  Manrope: null,
  Inter: "Inter:wght@400;500;600;700;800",
  Poppins: "Poppins:wght@400;500;600;700;800",
  Montserrat: "Montserrat:wght@400;500;600;700;800",
  "Playfair Display": "Playfair+Display:wght@400;500;600;700;800",
  Lora: "Lora:wght@400;500;600;700",
};

export const DESIGN_RADII = { Sharp: "0.4rem", Rounded: "1.25rem", "Extra Rounded": "1.75rem" };

function hexToRgb(hex) {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || "");
  return m ? `${parseInt(m[1], 16)} ${parseInt(m[2], 16)} ${parseInt(m[3], 16)}` : null;
}

function loadFont(name) {
  if (!DESIGN_FONTS[name]) return;
  const id = "gf-" + name.replace(/\W/g, "");
  if (document.getElementById(id)) return;
  const l = document.createElement("link");
  l.id = id; l.rel = "stylesheet";
  l.href = `https://fonts.googleapis.com/css2?family=${DESIGN_FONTS[name]}&display=swap`;
  document.head.appendChild(l);
}

export default function DesignVars() {
  const { content, settings } = useSettings();
  const d = content.design || {};
  useEffect(() => {
    const root = document.documentElement.style;
    if (d.accent) {
      const rgb = hexToRgb(d.accent);
      if (rgb) { root.setProperty("--gold-rgb", rgb); root.setProperty("--gold", d.accent); }
    }
    if (d.radius) root.setProperty("--radius-xl2", d.radius);
    const body = d.body_font || "Manrope";
    const head = d.heading_font || body;
    loadFont(body); loadFont(head);
    root.setProperty("--font-body", `"${body}", system-ui, sans-serif`);
    root.setProperty("--font-heading", `"${head}", system-ui, sans-serif`);
  }, [d.accent, d.radius, d.body_font, d.heading_font]);

  // Dynamic favicon from Website Settings (only override when a custom one is set;
  // otherwise the static /favicon.ico in index.html is used for crawlers/search).
  useEffect(() => {
    const href = settings.favicon_url;
    if (!href || href === "/logo.png") return;
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = href;
  }, [settings.favicon_url]);

  return null;
}
